// extracted by mini-css-extract-plugin
export var hidden = "_47-1";
export var leftPanel = "_47-2";
export var readonlyInspector = "_47-3";
export var rightPanel = "_47-0";